import { combineReducers, configureStore } from "@reduxjs/toolkit";
import errorReducer from "./errors/errors.reducer";
import listReducer from "./list/list.reducer";

const rootReducer = combineReducers({
    errorReducer,
    listReducer
});

export type RootState = ReturnType<typeof rootReducer>;

const store = configureStore({
    reducer: rootReducer,
});

export default store;
